import { render } from "./hisSubjectList.vue?vue&type=template&id=1d777e17"
import script from "./hisSubjectList.vue?vue&type=script&lang=js"
export * from "./hisSubjectList.vue?vue&type=script&lang=js"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__